import { useState } from 'react';

/** Accordion over a page's registry FAQ (the same array feeds the FAQPage JSON-LD). */
export function FaqList({ faq }: { faq: { q: string; a: string }[] }) {
  const [open, setOpen] = useState<number | null>(0);
  return (
    <div className="pcc-faq__list">
      {faq.map((f, i) => {
        const isOpen = open === i;
        return (
          <div className="pcc-faq__item" key={f.q}>
            <button type="button" className="pcc-faq__q" aria-expanded={isOpen} onClick={() => setOpen(isOpen ? null : i)}>
              <span>{f.q}</span>
              <span className="pcc-faq__mark" aria-hidden="true">
                {isOpen ? '\u2212' : '+'}
              </span>
            </button>
            {isOpen && <div className="pcc-faq__a">{f.a}</div>}
          </div>
        );
      })}
    </div>
  );
}
